import UploadDialog from "components/UploadDialog";
import { createAlertAction } from "data/app/appActions";
import api from "lib/api";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { createAlert } from "records/Alert";

interface Props {
	onNewViewAdded: () => void;
}

export default function ViewUpload({ onNewViewAdded }: Props) {
	const { t } = useTranslation();

	const reduxDispatch = useDispatch();

	const [isUploaded, setIsUploaded] = useState(false);
	const [error, setError] = useState<string | null>(null);

	/**
	 * Handles uploading the view
	 *
	 * @param file uploaded to the UploadDialog
	 */
	const handleUpload = useCallback(
		async file => {
			try {
				await api.view.uploadViewDefinition(file);

				setIsUploaded(true);
				onNewViewAdded();

				reduxDispatch(
					createAlertAction(
						createAlert({
							title: t("alerts.viewAdded.title"),
							status: "success",
							timeout: 3000,
						})
					)
				);
			} catch (error) {
				console.error(error);
				// Show message that view has failed to import if api call fails
				setError("viewImportFail");
			}
		},
		[onNewViewAdded, reduxDispatch, t]
	);

	const handleValidation = useCallback(
		async file => {
			try {
				const json = JSON.parse(file);
				handleUpload(json);
			} catch (err) {
				console.error(
					"There was a problem uploading selected file",
					err
				);
				setError("viewImportFail");
			}
		},
		[handleUpload]
	);

	return (
		<UploadDialog
			btnLabel={t("main.views.labels.importView")}
			title={t("main.views.labels.importView")}
			acceptJson
			onValidation={handleValidation}
			file="view"
			btnClass="mb-3 mb-md-0 text-nowrap"
			isUploaded={isUploaded}
			error={error}
			clearError={() => setError(null)}
		/>
	);
}
